var _defs, _g, _path, _path2, _path3;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45,
    zoomAndPan: "magnify",
    viewBox: "0 0 33.75 33.749998",
    height: 45,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "475c6c8e57"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 33.5 0 L 33.5 33.5 L 0 33.5 Z M 0 0 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#475c6c8e57)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 31.96875 36.316406 L 1.527344 36.316406 C -0.875 36.316406 -2.820312 34.371094 -2.820312 31.96875 L -2.820312 1.527344 C -2.820312 -0.875 -0.875 -2.820312 1.527344 -2.820312 L 31.96875 -2.820312 C 34.371094 -2.820312 36.316406 -0.875 36.316406 1.527344 L 36.316406 31.96875 C 36.316406 34.371094 34.371094 36.316406 31.96875 36.316406 Z M 31.96875 36.316406 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 27.898438 27.621094 L 20.902344 27.621094 L 5.691406 5.878906 L 12.6875 5.878906 Z M 21.734375 25.777344 L 24.523438 25.777344 L 11.855469 7.722656 L 9.070312 7.722656 Z M 21.734375 25.777344 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 7.90625 27.621094 L 15.738281 18.550781 L 14.710938 17.191406 L 5.683594 27.621094 Z M 7.90625 27.621094 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 17.238281 14.269531 L 18.222656 15.671875 L 26.679688 5.878906 L 24.507812 5.878906 Z M 17.238281 14.269531 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitterIcon.48fc71e2fc02b1a673d8978da48f8419.svg";
export { ForwardRef as ReactComponent };